import { render, staticRenderFns } from "./AcomodacionSubTab.vue?vue&type=template&id=22975038&"
import script from "./AcomodacionSubTab.vue?vue&type=script&lang=js&"
export * from "./AcomodacionSubTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports